const blockFields = `
  id
  typeHandle
  idName
  heading
  subheading
  list {
    item
  }
  desktopImage {
    url @transform(mode: "crop", width: 2000, immediately: true)
    title
    hasFocalPoint
    focalPoint
  }
  mobileImage {
    url @transform(mode: "crop", width: 640, immediately: true)
    title
    hasFocalPoint
    focalPoint
  }
  copy
  button {
    type
    url
    text
    target
  }
`

export const CBackgroundImageListFragments = {
  field: `
    fragment backgroundImageList on backgroundImageList_MatrixField {
      ... on backgroundImageList_block_Entry {
        ${blockFields}
      }
    }
  `,
  uiField: `
    fragment uiBackgroundImageList on uiBackgroundImageList_MatrixField {
      ... on uiBackgroundImageList_block_Entry {
        ${blockFields}
      }
    }
  `,
}
